import { IDashboardFilterInput } from '../../../../../../utils/apollo/graphqlSchema';
import { IDraftDashboardCustomization } from '../../../../../../redux/slices/dashboards/dashboardInstance';
import { parseFilterToInput } from '../../../../../../utils/filterFields';
import { MaybeNil } from '../../../../../../utils/interfaces';

interface IArguments {
  draftCustomization: IDraftDashboardCustomization;
  schemaId: MaybeNil<string>;
}

const prepareDashboardFilterInput = ({
  draftCustomization,
  schemaId,
}: IArguments): IDashboardFilterInput => {
  const result: IDashboardFilterInput = {
    filter: null,
    schemaId: schemaId ?? null,
    /**
     * Datepicker is not saved with the filter because causes confusion.
     * Chart date ranges aren't synced with it until user executes the dashaboard
     */
    datePicker: null,
  };

  if (draftCustomization.filter?.conditions?.length && schemaId) {
    result.filter = parseFilterToInput(draftCustomization.filter, schemaId);
  }

  return result;
};

export default prepareDashboardFilterInput;
